import React from "react";
import icons from "../Images/SVGRepo_iconCarrier.svg";
import Futures from "../Images/Future.png";
import { useTranslation } from "react-i18next";

export const Refinding = () => {
  const { t } = useTranslation();

  const features = t("refinding.features", { returnObjects: true });

  return (
    <div
      className="font-sans mb-1 lg:mb-14 p-4"
      style={{
        backgroundImage: `url(${Futures})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
      id="services"
    >
      <p className="flex justify-center text-4xl font-sans sm:text-4xl lg:text-5xl text-[#EF3B3B] font-semibold text-start wow fadeInUp mt-6">
        <span className="flex justify-center flex-col font-bold items-center mt-3">
          <svg
            width="129"
            height="27"
            viewBox="0 0 129 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mb-6"
          >
            <rect width="4" height="27" fill="white" />
            <rect x="25" width="4" height="27" fill="white" />
            <rect x="50" width="4" height="27" fill="white" />
            <rect x="75" width="4" height="27" fill="white" />
            <rect x="100" width="4" height="27" fill="white" />
            <rect x="125" width="4" height="27" fill="white" />
          </svg>
        </span>
      </p>
      <div className="lg:mx-24">
        <div className="lg:text-4xl font-geo text-2xl font-bold wow fadeInUp text-[#EF3B3B] mt-1 mb-5">
          {t("refinding.title")}
        </div>
        <div className="lg:text-2xl text-xl font-bold wow fadeInUp text-gray-200 mt-1 mb-5">
          {t("refinding.subtitle")}
        </div>
        <div className="text-center text-white font-bold text-xl">
          {t("refinding.description")}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 mt-6 gap-6 py-10 wow fadeInUp">
          {features.map((feature: string, index: number) => (
            <div key={index} className="flex items-center justify-start gap-4">
              <img src={icons} alt="" className="h-4" />
              <div className="text-left text-white text-xl font-medium">
                {feature}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
